<template>
  <div class="personal_center">
    <div class="personal_header">
      <div class="personal_header_inner">
        <div class="inner">
          <div class="avatar_box">
            <div class="img_outline">
              <img :src="$store.getters.avatar || avatardefauter" alt="" />
            </div>
            <div class="txt">
              <div class="title_txt">{{ $store.getters.name }}</div>
              <div class="sub_title_txt">Hi,快来让大家认识你吧！</div>
            </div>
          </div>
          <div class="outLine">
            <div class="outline_item">
              <p class="top">
                <span>{{ totol.earlyWarningNum }} </span>个
              </p>
              <p class="middle">学业预警帮扶</p>
              <p class="bottom">
                完成率 <span>{{ totol.totalStudy }}%</span>
              </p>
            </div>
            <div class="outline_item">
              <p class="top">
                <span>{{ totol.totalScore }} </span>分
              </p>
              <p class="middle">学业综合评分</p>
              <p class="bottom">
                班级排名 <span>{{ totol.clazzScoreRanking }}</span>
              </p>
            </div>
            <div class="outline_item">
              <p class="top">
                <span
                  >{{
                    parseInt((totol.totalLeaningTime / 60 / 60) * 10) / 10 || 0
                  }} </span
                >小时
              </p>
              <p class="middle">在线学习时长</p>
              <p class="bottom">
                班级排名 <span>{{ totol.clazzLeaningRanking }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="primarycoverage secondary_page_bg">
      <div class="btn_nav">
        <div class="inner">
          <span
            :class="['nav_item', 'nav_magin', activeName == '1' ? 'nav_active' : '']"
            @click="handleClick('1')"
            >学习记录</span
          >
          <span
            :class="['nav_item', 'nav_magin', activeName == '2' ? 'nav_active' : '']"
            @click="handleClick('2')"
            >我的课程</span
          >
          <span
            :class="['nav_item', 'nav_magin', activeName == '3' ? 'nav_active' : '']"
            @click="handleClick('3')"
            >我的预警</span
          >
          <span
            :class="['nav_item', 'nav_magin', activeName == '4' ? 'nav_active' : '']"
            @click="handleClick('4')"
            >我的测评</span
          >
          <span
            :class="['nav_item', 'nav_magin', activeName == '5' ? 'nav_active' : '']"
            @click="handleClick('5')"
            >我的考试</span
          >
          <el-badge :hidden="!unreadMsgNum" :value="unreadMsgNum" class="nav_magin">
            <span
              :class="['nav_item', activeName == '6' ? 'nav_active' : '']"
              @click="handleClick('6')"
              >我的消息</span
            >
          </el-badge>
        </div>
      </div>
      <div class="inner">
        <div class="content_item" v-show="activeName == '1'">
          <learning-record
            ref="study"
            @setHandleDetail="getHandleDetailCharge"
          ></learning-record>
        </div>
        <div class="content_item" v-show="activeName == '2'">
          <div class="my_course_nav">
            <div
              :class="['course_nav_item', navActive == index ? 'nav_active' : '']"
              v-for="(item, index) in nav"
              :key="index"
              @click="handleMyCourse(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
          <el-row
            :gutter="18"
            class="course_box"
            v-if="myCourseList.length || loading"
            v-loading="loading"
          >
            <el-col
              :span="6"
              v-for="(item, index) in myCourseList"
              :key="index"
              class="course_items"
            >
              <MyCourseItem
                :course="item"
                @setCoursePath="handleCoursePath"
              ></MyCourseItem>
            </el-col>
          </el-row>
          <el-empty
            description="暂无学习课程"
            v-if="myCourseList.length == 0 && !loading"
          ></el-empty>
        </div>
        <div class="content_item" v-show="activeName == '3'">
          <div
            class="yvjing_list"
            v-if="bangfuList.length > 0 || courseLoading"
            v-loading="courseLoading"
          >
            <div class="yvjing_item" v-for="(item, index) in bangfuList" :key="index">
              <div class="yvjing_title">
                <p>
                  <span class="left">{{ item.courseName }}</span>
                  <span class="right"
                    >完成进度{{
                      item.traineeList.length > 0 ? item.traineeList[0].totalStudy : "0"
                    }}%</span
                  >
                </p>
                <span class="time">{{ parseDate(item.createTime, "{y}/{m}/{d}") }}</span>
              </div>
              <div class="condition" v-if="item.conditionIds.length > 0">
                预警条件：<span
                  v-for="conditionId in item.conditionIds"
                  :key="conditionId.value"
                  >{{ conditionId.label }}；</span
                >
              </div>
              <div class="pingyv_lookcourse">
                <span class="ellipsis">教师评价：{{ item.teacherComments }}</span>
                <a href="javascript:;" @click="handleCourseList(item)">
                  <i class="el-icon-loading" v-if="item.loading"></i>
                  <span v-else>查看详情</span>
                </a>
              </div>
              <el-row :gutter="18" class="course_box" style="min-height: auto">
                <el-col
                  class="course_items"
                  :span="6"
                  v-for="(course, courseIndex) in item.courseList"
                  :key="courseIndex"
                >
                  <MyCourseItem
                    :course="course"
                    @setCoursePath="handleCoursePath"
                  ></MyCourseItem>
                </el-col>
              </el-row>
            </div>
          </div>
          <el-empty
            description="你真的很优秀"
            v-if="bangfuList.length == 0 && !courseLoading"
          ></el-empty>
        </div>
        <div class="content_item" v-show="activeName == '4'">
          <div
            class="ceping_list"
            v-if="cepingList.length > 0 || cepingLoading"
            v-loading="cepingLoading"
          >
            <div
              class="ceping_item"
              v-for="(item, index) in cepingList"
              :key="index"
              @click="handleceping(item)"
            >
              <div class="ceping_title ellipsis">{{ item.title }}</div>
              <div class="quiz_conclusion">
                <p class="conclusion_title">{{ item.quizConclusionList[0].title }}</p>
                <p class="conclusion_text ellipsis">
                  测评评语：{{ item.quizConclusionList[0].comment }}
                </p>
              </div>
              <div class="time">
                {{ parseDate(item.createTime, "{y}/{m}/{d}") }}
              </div>
            </div>
          </div>
          <el-empty
            description="暂无评测信息"
            v-if="cepingList.length == 0 && !cepingLoading"
          ></el-empty>
          <div v-if="cepingTotal > 0" style="text-align: center">
            <el-pagination
              background
              @current-change="handleCepingChange"
              :current-page="1"
              :page-size="cepingParams.pageSize"
              layout="total, prev, pager, next"
              :total="cepingTotal"
            />
          </div>
        </div>
        <div class="content_item" v-show="activeName == '5'">
          <personalExam></personalExam>
        </div>
        <div class="content_item" v-show="activeName == '6'">
          <ul class="news_list" v-if="newsList.length > 0">
            <li class="news_item" v-for="item in newsList" :key="item.id">
              <div class="news_title">
                <span class="left ellipsis">
                  <span>{{ item.title }}，</span>
                  <a href="javascript:;" @click="putNewsType(item)">查看详情</a>
                </span>
                <span class="right">
                  <i v-if="!item.isRead"></i>
                  {{ item.createTime }}
                </span>
              </div>
              <div class="news_content ellipsis">{{ item.replyContent }}</div>
            </li>
          </ul>
          <el-empty description="暂无信息" v-else></el-empty>
          <div v-if="newsTotal > 0" style="text-align: center">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="1"
              :page-size="newsParams.pageSize"
              layout="total, prev, pager, next"
              :total="newsTotal"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LearningRecord from "@/components/LearningCenterComponents/LearningRecord";
import MyCourseItem from "@/components/MyCourseItem";
import {
  myStudyData,
  getPcMyCourse,
  getEarlyWarningByEarlyWarningIdAndTraineeId,
  traineeEarlyWarningDirectory,
  getMessageNotification,
  putNotification,
  getMessageNotificationCount,
} from "@/api/user";
import { MecareerQuiz } from "@/api/evaluating";
import { parseDate } from "@/utils";
//我的考试
import personalExam from "./personalExam.vue";
export default {
  name: "PersonalCenter",
  components: {
    LearningRecord,
    personalExam,
    MyCourseItem,
  },
  data() {
    return {
      avatardefauter: require("@/assets/images/avatardefauter.png"),
      activeName: "1",
      navActive: 0,
      yjnavActive: 0,
      nav: [
        {
          title: "全部",
          value: "",
        },
        {
          title: "正在学习",
          value: 0,
        },
        {
          title: "已结束",
          value: 2,
        },
      ],
      myCourseList: [],
      loading: true,
      bangfuList: [],
      courseLoading: true,
      cepingList: [],
      cepingLoading: true,
      cepingTotal: 0,
      cepingParams: {
        pageSize: 10,
        pageNum: 1,
      },
      totol: {},
      newsParams: {
        pageSize: 10,
        pageNum: 1,
      },
      newsList: [],
      newsTotal: 0,
      unreadMsgNum: 0,
      newsLoading: true,
    };
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", null);
    this.myStudyData();
    this.getMessageNotificationCount();
  },
  methods: {
    // 日期格式化
    parseDate,
    handleClick(i) {
      this.activeName = i;
      if (i == "1") {
        this.$nextTick(() => {
          this.$refs.study.lineChart.resize();
        });
      } else if (i == "2") {
        this.getPcMyCourse({
          courseState: "",
        });
      } else if (i == "3") {
        this.traineeEarlyWarningDirectory();
      } else if (i == "4") {
        this.listCareerQuiz();
      } else if (i == "6") {
        this.getMessageNotification();
      }
    },
    myStudyData() {
      myStudyData({
        traineeId: this.$store.getters.userId,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.totol = res.data;
        }
      });
    },
    getPcMyCourse(params) {
      this.loading = true;
      getPcMyCourse(params)
        .then((res) => {
          if (res.code == 200) {
            this.myCourseList = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取未读数量
    getMessageNotificationCount() {
      getMessageNotificationCount().then((res) => {
        this.unreadMsgNum = res.data;
      });
    },
    // 获取消息提醒
    getMessageNotification() {
      this.newsLoading = true;
      getMessageNotification(this.newsParams)
        .then((res) => {
          this.newsList = res.rows;
          this.newsTotal = res.total;
          this.newsLoading = false;
        })
        .catch(() => (this.newsLoading = false));
    },
    // 修改状态
    putNewsType(item) {
      this.getHandleDetailCharge(item);
      if (item.isRead) return;
      putNotification(item.id).then((res) => {
        item.isRead = true;
        this.unreadMsgNum -= 1;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.newsParams.pageNum = val;
      this.getMessageNotification();
    },
    // 我的课程筛选切换
    handleMyCourse(item, index) {
      this.navActive = index;
      this.getPcMyCourse({
        courseState: item.value,
      });
    },
    handleCoursePath(item) {
      let id = item.id || item.courseId;
      const rourl = this.$router.resolve({
        path: "/coursedetails",
        query: { id: id, professionId: item.professionId },
      });
      window.open(rourl.href);
    },
    getHandleDetailCharge(data) {
      let rourl = this.$router.resolve({
        path: "/coursedetails",
        query: {
          id: data.courseId,
          chapterId: data.chapterId,
          professionId: data.professionId,
        },
      });
      window.open(rourl.href);
    },
    traineeEarlyWarningDirectory() {
      this.courseLoading = true;
      traineeEarlyWarningDirectory({ traineeId: this.$store.getters.userId })
        .then((res) => {
          if (res.data.length > 0) {
            this.bangfuList = res.data.map((v) => ({
              ...v,
              loading: false,
              courseList: [],
            }));
          }
          console.log(this.bangfuList);
          this.courseLoading = false;
        })
        .catch(() => {
          this.courseLoading = false;
        });
    },
    handleCourseList(item) {
      item.loading = true;
      getEarlyWarningByEarlyWarningIdAndTraineeId({
        traineeId: this.$store.getters.userId,
        earlyWarningId: item.id,
      })
        .then((res) => {
          console.log(res);
          const materials = res.data.materials;
          const courseCompletionRate = res.data.traineeStudyVO.courseCompletionRate.map(
            (v) => ({
              ...v,
              studyProgress: v.completionRate,
            })
          );
          item.courseList = materials.map((v) => ({
            ...v,
            ...courseCompletionRate.find((m) => m.courseId == v.id),
          }));
          item.loading = false;
        })
        .catch(() => {
          item.loading = false;
        });
    },
    listCareerQuiz() {
      this.cepingLoading = true;
      MecareerQuiz(this.cepingParams)
        .then((res) => {
          this.cepingLoading = false;
          this.cepingList = res.rows;
          this.cepingTotal = res.total;
        })
        .catch(() => {
          this.cepingLoading = false;
        });
    },
    handleCepingChange() {
      this.cepingParams.pageNum = val;
      this.listCareerQuiz();
    },
    handleceping(item) {
      this.$router.push({
        path: "/evaluaDetail",
        query: { id: item.id, mydeta: 1, indresult: 1 },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: bertha;
  src: url("~@/assets/fount/Bertha.ttf");
}
.personal_center {
  background: #f7f7f7;
  .personal_header {
    background: url("~@/assets/images/secound_bg.png");
    background-size: cover;
    .personal_header_inner {
      padding: 32px 0;
      //background-color: rgb(254 255 255 / 0.3);
      //backdrop-filter: blur(10px);
      //-webkit-backdrop-filter: blur(5px);
    }
    // backdrop-filter: blur(50px);
    .inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .avatar_box {
        display: flex;
        align-items: center;
        color: #333;
        .txt {
          padding-left: 24px;
          .title_txt {
            font-size: 18px;
            margin-bottom: 10px;
          }
          .sub_title_txt {
            font-size: 14px;
          }
        }
      }
      .img_outline {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
        border: 3px solid #fff;
      }
      .outLine {
        display: flex;
        .outline_item {
          width: 180px;
          .top {
            font-size: 16px;
            color: #B18227;
            line-height: 1;
            margin-bottom: 13px;
            span {
              font-size: 60px;
              font-family: bertha;
            }
          }
          .middle {
            font-size: 14px;
            line-height: 1;
            padding-bottom: 9px;
            margin-bottom: 8px;
            position: relative;
            color: #B18227;
            &::before {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              height: 1px;
              width: 14px;
              background-color: #B18227;
            }
          }
          .bottom {
            font-size: 16px;
            line-height: 1;
          }
        }
      }
    }
  }
  .primarycoverage {
    padding: 53px 0;
    .btn_nav {
      .inner {
        display: flex;
        border-bottom: 1px solid #eeeeee;
        border-radius: 0;
        border-start-start-radius: 8px;
        border-start-end-radius: 8px;
        padding-top: 40px;
        padding-bottom: 0;
        ::v-deep .el-badge__content.is-fixed {
          right: 14px;
        }
        .nav_item {
          display: inline-block;
          width: 110px;
          height: 40px;
          border: 1px solid #045923;
          border-radius: 20px;
          line-height: 38px;
          text-align: center;
          cursor: pointer;
        }
        .nav_magin {
          margin-right: 20px;
          margin-bottom: 20px;
        }
        .nav_active {
          background: #045923;
          color: #ffffff;
        }
      }
    }
    .inner {
      background: #fff;
      border-end-end-radius: 8px;
      border-end-start-radius: 8px;
      padding: 30px;
    }
  }
  .my_course_nav {
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;
    .course_nav_item {
      padding: 5px;
      margin-left: 20px;
      margin-top: 5px;
      cursor: pointer;
      &:first-of-type {
        margin-left: 0;
      }
      &:hover,
      &.nav_active {
        color: #1d4434;
      }
    }
  }
  .course_box {
    margin-top: 30px;
    min-height: 300px;
    .course_items {
      margin-bottom: 44px;
    }
  }
  .yvjing_list {
    margin-top: 5px;
    min-height: 300px;
    .yvjing_item {
      border-bottom: 1px solid #d2d2d2;
      margin-bottom: 20px;
      .condition {
        color: #1d4434;
        margin-bottom: 10px;
      }
    }
    .yvjing_title {
      margin-bottom: 20px;
      p {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1;
        margin-bottom: 16px;
        .left {
          font-size: 24px;
        }
        .right {
          font-size: 14px;
          color: #1d4434;
        }
      }
      .time {
        font-size: 14px;
        color: #cccccc;
      }
    }
    .pingyv_lookcourse {
      display: flex;
      margin-bottom: 25px;
      span {
        flex: 1;
      }
      a {
        color: #1d4434;
        padding-left: 5px;
      }
    }
  }
  .ceping_list {
    margin-top: 5px;
    min-height: 300px;
    .ceping_item {
      position: relative;
      border-bottom: 1px solid #d2d2d2;
      margin-bottom: 20px;
      padding-bottom: 20px;
      cursor: pointer;
      .ceping_title {
        line-height: 1;
        font-size: 20px;
        margin-bottom: 20px;
      }
      .quiz_conclusion {
        padding: 20px 27px 30px;
        background: #f6f6f6;
        .conclusion_title {
          font-size: 24px;
          font-weight: 400;
          color: #1d4434;
          line-height: 1;
          margin-bottom: 20px;
        }
        .conclusion_text {
          font-size: 14px;
          color: #666666;
          line-height: 1;
        }
      }
      .time {
        font-size: 14px;
        color: #cccccc;
        margin-top: 16px;
      }
      .ceping_title {
        margin-bottom: 15px;
      }
      .ceping_subtitle {
        display: flex;
        div {
          width: 50%;
          overflow: hidden;
          height: 20px;
        }
        a {
          color: #1d4434;
          padding-left: 5px;
        }
      }
    }
  }
  .news_list {
    .news_item {
      margin-bottom: 20px;
      border: 1px solid #eeeeee;
      .news_title {
        padding: 10px 24px;
        background: #f2f2f2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          flex: 1;
          font-weight: bold;
          a {
            color: #1d4434;
          }
        }
        .right {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #999999;
          i {
            height: 10px;
            width: 10px;
            border-radius: 50%;
            background-color: #f40;
            margin-right: 5px;
          }
        }
      }
      .news_content {
        padding: 20px 24px;
      }
    }
  }
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
